<template>
  <div id="home"
       v-loading="loading">
    <div :class="`header header_${$i18n.locale}`">
      <!-- <div class="header" :style="{backgroundImage: `url(${bgImg})`}"> -->
      <div class="justify-space-between top">
        <img class="dsal_logo"
             src="./assets/web/dsal_logo.png"
             alt />
        <LangSelect @command="command"></LangSelect>
      </div>
    </div>
    <div class="home_main">
      <div class="container"
           style="padding:0;">
        <!-- 課程列表 -->
        <!-- <TableList
        :title="$t('message.course_list')"
        :data="courses"
        label="course.title"
        @current-change="courseCurrentChange"
        ></TableList>-->
        <div class="home_course_list">
          <div class="justify-align-center home_course_list_title">
            <img src="./assets/web/TitleL.png"
                 alt />
            <span>{{$t('message.course_list')}}</span>
            <img src="./assets/web/TitleR.png"
                 alt />
          </div>
          <div class="home_course_items">
            <div class="course_list_item"
                 v-for="(item,index) in courses"
                 :key="index">
              <img src="./assets/web/Course01.png"
                   class="course_list_left" />
              <div class="course_list_right">
                <div class="course_title">{{item.course.title}}</div>
                <div class="course_describe html-box"
                     v-html="item.course.summary"></div>
                <div class="course_btn">
                  <span style="float:right;"
                        @click="checkQuestion(item)">
                        <i v-if="selectCourse.course && selectCourse.course.id === item.course.id && btnLoading" class="el-icon-loading"></i>
                        {{$t('message.course_entry')}}
                        </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="foot">© {{new Date().getFullYear()}} - {{$t('message.copyright')}}</div>

    <!-- 優先序彈窗 -->
    <el-dialog title
               :visible.sync="showPriority"
               class="priority_dialog">
      <div class="priority_title">{{priority.length > 0? priority[0].group : ''}}</div>
      <div class="priority_tips">{{$t('message.priority_tips')}}</div>
      <div class="priority_list">
        <div class="priority_items"
             v-for="item in priority"
             :key="item.id"
             @click="toCourse(item)">
          <span>
            《{{item.title}}》
            <span class="current_course">{{item.id == selectCourse.course.id ? $t('message.current'):''}}</span>
          </span>
          <el-button>
            {{$t('message.goto_course')}}
            <i class="el-icon-arrow-right el-icon--right"></i>
          </el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 問卷彈窗 -->
    <QuestionTipsDialog :courseTitle="selectCourse.course && selectCourse.course.title" :show="showQuestionTips" :id="selectCourse.questionnaires && selectCourse.questionnaires.length > 0 && selectCourse.questionnaires[0].id" @close="showQuestionTips = false" @handleContinue="handleContinue"></QuestionTipsDialog>
  </div>
</template>

<script>
import CourseAPI from "./api/CourseAPI";
import TableList from "./components/TableList";
import LangSelect from "./components/LangSelect";
import QuestionTipsDialog from "./components/QuestionTipsDialog";
export default {
  components: { TableList, LangSelect, QuestionTipsDialog },
  data () {
    return {
      courses: [],
      questionnaires: [],
      loading: false,
      btnLoading: false,
      showPriority: false,
      selectCourse: {},
      priority: [],
      showQuestionTips: false,
    };
  },
  computed: {},
  methods: {
    command () {
      this.get();
    },
    async checkQuestion(row){
      try {
        if(!row.course.id) return false;
        this.btnLoading = true;
        this.selectCourse = row;
        const locale = this.$i18n.locale;
        sessionStorage.setItem("courseId", row.course.id);
        sessionStorage.setItem("toLast", "true");
        // 判斷是否需要登錄，不需要則跳轉預覽
        if(row.auth === false){
          this.$router.push({
            path: '/index',
            query: {
              courseVersionId: row.course.id,
              auth: 1,
            }
          });
          return;
        } else {
          this.$store.state.auth = null;
          this.$store.commit("changePreview", {
            isPreview: false,
            previewType: null,
            PCourseId: null,
            PCourseVersionId: null,
            auth: null,
          });
        }
        const { progress = 0 } = await CourseAPI.getOne(row.course.id, locale);
        const questionnaires = await CourseAPI.listQuestionnaireByCourse(row.course.id, locale);
        const questionnaire = questionnaires.length > 0 && questionnaires[0] || {};
        // console.log('questionnaire: ', questionnaire.participated);
        if(this.questionnaires.length > 0 && progress >= 0.8 && !questionnaire.participated){
          this.showQuestionTips = true;
        }else{
          this.courseCurrentChange(row);
        }
        this.btnLoading = await false;
      } catch (error) {
        this.$error(error);
      }
    },
    courseCurrentChange (row) {
      // console.log(row);
      this.selectCourse = row;
      const locale = this.$i18n.locale;
      CourseAPI.checkPriority(row.course.id, locale)
        .then(res => {
          // console.log(res);
          if (res.length < 2) {
            this.showPriority = false;
            this.$router.push({
              path: "/index"
            });
          } else {
            this.showPriority = true;
            this.priority = res;
            // this.priority = res.filter(
            //   item => item.id != this.selectCourse.course.id
            // );
          }
        })
        .catch(err => {
          this.showPriority = false;
          this.$error(err);
          // console.log(err);
        });

      // sessionStorage.setItem("courseId", row.course.id);
      // this.$router.push({
      //   path: "/index"
      // });
    },
    toCourse (item) {
      this.selectCourse = item;
      sessionStorage.setItem("courseId", item.id);
      this.$router.push({
        path: "/index"
      });
    },
    questionCurrentChange (row) {
      // console.log(row);
      this.$router.push({
        path: "/question",
        query: {
          id: row.id,
          type: "public"
        }
      });
    },
    get () {
      this.loading = true;
      const locale = this.$i18n.locale;
      CourseAPI.list(locale)
        .then(res => {
          this.loading = false;
          this.courses = res;
        })
        .catch(err => {
          this.loading = false;
          this.$error(err);
          // console.log(err);
        });
    },
    handleContinue() {
        this.showQuestionTips = false;
        this.courseCurrentChange(this.selectCourse);
    }
  },
  async created () {
    const code = this.$route.query.courseCode;
    // 根據url參數設定語言
    if (this.$route.query.lang) {
      localStorage.setItem("lan", this.$route.query.lang.toUpperCase());
      this.$i18n.locale = this.$route.query.lang.toUpperCase();
      if (this.$route.query.lang.toUpperCase() == "EN") {
        localStorage.setItem("sound", "E");
      } else if (this.$route.query.lang.toUpperCase() == "PT") {
        localStorage.setItem("sound", "P");
      } else if (this.$route.query.lang.toUpperCase() == "ZH_CN") {
        localStorage.setItem("sound", "CN");
      } else {
        localStorage.setItem("sound", "TW");
      }
    }
    const locale = this.$i18n.locale;
    if (code) {
      const course = await CourseAPI.getCourseByCode(code, locale);
      this.checkQuestion({
        auth: course.auth,
        course: course,
      })
      return;
    }
    this.get();
  },
  beforeCreate () { },
  mounted () { }
};
</script>

<style lang="scss" scoped>
// #home {
//   background: #fff;
//   height: 100%;
//   .header {
//     height: 229px;
//     background-image: url("./assets/web/publicBanner.png");
//     background-repeat: no-repeat;
//     background-position: center;
//     .top {
//       .dsal_logo {
//         margin: 5px 6px 4px 9px;
//         width: 296px;
//       }
//     }
//   }
//   .home_main {
//     background: #fff;
//     overflow: hidden;
//     padding: 0 16px 16px 16px;
//   }
// }
.priority_dialog {
  /deep/.el-dialog {
    max-width: 500px;
    width: 90%;
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__headerbtn {
      top: 5px;
      right: 5px;
    }
  }
  .priority_title {
    text-align: center;
    color: rgba(246, 102, 3, 1);
    font-size: 22px;
  }
  .priority_tips {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }
  .priority_list {
    padding-top: 10px;
    .priority_items {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: rgba(240, 240, 240, 1);
      border-radius: 4px;
      font-size: 16px;
      color: #333;
      padding: 9px 12px;
      margin-top: 8px;
      cursor: pointer;
      .el-button {
        color: #fff;
        background: rgba(22, 182, 149, 1);
        padding: 8px 12px;
        font-size: 14px;
      }
    }
  }
  .current_course {
    color: #cb4821;
  }
}
/deep/.el-dialog__body {
  word-break: normal;
}
</style>